import { combineReducers } from "redux";
import talent from "store/reducers/dashboard/talent";
import jobs from "store/reducers/dashboard/jobs";
import tasks from "store/reducers/dashboard/tasks";
import issues from "store/reducers/dashboard/issues";
import performance from "store/reducers/dashboard/performance";
import slots from "store/reducers/dashboard/slots";
import recruiters from "store/reducers/dashboard/recruiters";
import recruitmentReportByMetro from "store/reducers/dashboard/recruitmentReportByMetro";
import futureWorkByClient from "store/reducers/dashboard/futureWorkByClient";
import futureWorkBy from "store/reducers/dashboard/futureWorkBy";
import metroRecruiters from "store/reducers/dashboard/metroRecruiters";
import metroClients from "store/reducers/dashboard/metroClients";
import clientStores from "store/reducers/dashboard/clientStores";
import dedicatedWorkerReport from 'store/reducers/dashboard/dedicatedWorkerReport';
import travelMerchandiserDedicatedReport from 'store/reducers/dashboard/travelMerchandiserDedicatedReport';

export default combineReducers({
  talent,
  jobs,
  tasks,
  issues,
  performance,
  slots,
  recruiters,
  recruitmentReportByMetro,
  futureWorkByClient,
  futureWorkBy,
  dedicatedWorkerReport,
  travelMerchandiserDedicatedReport,
  metroRecruiters,
  metroClients,
  clientStores
});;
